import { useCallback, useEffect, useMemo } from "react";

import { CombinedCustomEvents } from "@intelligems/ig-types";

export const useFilterEventsManagerData = (
  events: CombinedCustomEvents,
  searchInput: string,
  showArchived: boolean,
  setShowArchived: (isArchived: boolean) => void
) => {
  // Check if search matches any archived events
  const checkForArchivedMatches = useCallback(
    (searchTerm: string) => {
      if (!searchTerm) return false;

      const sanitizedInput = searchTerm.toLowerCase();
      return events.some(
        (row) =>
          "id" in row &&
          row.archivedAtTs &&
          row.name?.toLowerCase().includes(sanitizedInput)
      );
    },
    [events]
  );

  // Update showArchived when search matches archived events
  useEffect(() => {
    if (searchInput && !showArchived && checkForArchivedMatches(searchInput)) {
      setShowArchived(true);
    }
  }, [searchInput, showArchived, checkForArchivedMatches, setShowArchived]);

  // Filter the events
  return useMemo(() => {
    // Apply search filter first
    let filtered = events;

    if (searchInput) {
      const sanitizedInput = searchInput.toLowerCase();
      filtered = events.filter((row) =>
        "id" in row
          ? row.name?.toLowerCase().includes(sanitizedInput)
          : row.event_id?.toLowerCase().includes(sanitizedInput)
      );
    }

    // Then filter by archived status if needed
    if (!showArchived) {
      filtered = filtered.filter((row) => {
        if ("id" in row) {
          return !row.archivedAtTs;
        }
        return true;
      });
    }

    return filtered;
  }, [events, searchInput, showArchived]);
};
